	/**
	 * @deprecated
	 * NeedWaitHander: handles the message of "TYPE_CHAT_NEED_WAIT"
	 * When constructed, the period and message are checked and if both defined the handler is enabled.
	 * When received, if the handler is enabled the count is checked to the period and the message is sent to chat text area 
	 * 
	 * Sample settings for the MXML CDATA area
	 * 		needwaitPeriod: 10,
	 * 		needwaitSoonThreshold: 10,			  
	 * 		needwaitMessageFirstDefault: "Sorry for the delay, please wait",	// This is the message to be used if the pattern(s) in the needwaitMessageFirst text cannot be resolved
	 * 		needwaitMessageDefault: "Still busy, please wait",					// This is the message to be used if the pattern(s) in the needwaitMessage text cannot be resolved
	 * 		needwaitMessageFirst: "Sorry for the delay, your are <<QUEUE-POSITION>> on the queue, we will be with you in <<SECOND-WAIT-TIME>> seconds.",
	 * 		needwaitMessageFirstSoon: "Sorry for the delay, we will be with you soon.", // This is the message if the wait time is less than needwaitPeriod (in seconds)
	 * 		needwaitMessageFirstMinutes: "Sorry for the delay, we will be with you in about <<MINUTES-ONLY-WAIT-TIME>> minutes.", // This is the message if the wait time is to be shown in minutes only (rounded)
	 * 		needwaitMessageFirstSeconds: "Sorry for the delay, we will be with you in about <<SECOND-WAIT-TIME>> seconds.", // This is the message if the wait time is to be shown in seconds without minutes 
	 * 		needwaitMessageMinutes: "We are still busy, we will be with you in <<MINUTE-WAIT-TIME>> minutes <<SECOND-WAIT-TIME>> seconds.",     
	 * 		needwaitMessage: "We are still busy, we will be with you in <<SECOND-WAIT-TIME>> seconds.", 
	 * 	    needwaitMessageFirst: "Sorry, there are no agents available to help you",
	 * 
	 * Special Cases:
	 * 		MessageFields.KEY_CHAT_WAIT_EST_ASSIGN_TIME == -1        Means no agents available
	 * 		MessageFields.KEY_CHAT_WAIT_EST_ASSIGN_TIME ==  0		 Means agent will be available real soon.   
	 * 																 ... Since this is less than needwaitSoonTheshold (default 10 seconds) 
	 * 																 ... we have this covered
	 * 	Note:
	 * 		cntMessage starts with a count of -1 and increments for each queue message. 
	 * 			If the count is -1 then we know that the message is the first message.
	 * 			The first message has a diffent text then subsequent messages.
	 *      
	 * New behavior for array of messages:
	 * message format: "message1 | {countHint} |{timeShift} // message2 |{countHint} | {timeShift} //  message3 |{countHint} | {timeShift}//..."
	 *  countHint - defines how many times a message will be displayed
	 * timeShift - defines time interval from previous message
	 * if countHint is -1 a message will be displayed infinitely
	 *
	 * Sample:
	 *
	 *  needWaitSequenceMessages: "message1 | 1 |10 // message2 |-1 | 10",
	 *  processingBehavior: "SEQUENCE_MESSAGE_PROCESSING",

	 * @author Fred A Pinn, fpinn@TouchCommerce.com, ahlinski
	 * @mxmlc
	 * @see ClientApplicationMessageHandler
	 */
/**
 * package: com.inq.flash.client.control.messagehandlers
 * class: NeedWaitHandler
 * @extends com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler 
 * @constructor
 */
com.inq.flash.client.control.messagehandlers.NeedWaitHandler = function() {
	com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.call(this,com.inq.flash.client.data.MessageFields.TYPE_CHAT_NEED_WAIT);
	haxe.Log.trace("NeedWaitHandler.Constructor",{ fileName : "NeedWaitHandler.hx", lineNumber : 103, className : "com.inq.flash.client.control.messagehandlers.NeedWaitHandler", methodName : "new"});
	
	com.inq.flash.client.control.messagehandlers.NeedWaitHandler.cntMessage = -1;
	
	/* Command below added for http://dev.inq.com/jira/browse/REQ-1938 */
	this.needwaitMessageFirstDefault = com.inq.utils.Util.getConfig("needwaitMessageFirstDefault",com.inq.flash.client.control.messagehandlers.NeedWaitHandler.NEED_WAIT_MESSAGE_FIRST_DEFAULT);
	this.needwaitMessageDefault = com.inq.utils.Util.getConfig("needwaitMessageDefault",com.inq.flash.client.control.messagehandlers.NeedWaitHandler.NEED_WAIT_MESSAGE_DEFAULT);
	this.needwaitMessageNoAgentAvailable = com.inq.utils.Util.getConfig("needwaitMessageNoAgentAvailable",com.inq.flash.client.control.messagehandlers.NeedWaitHandler.NEED_WAIT_MESSAGE_DEFAULT);
	this.needwaitMessageFirstNoAgentAvailable = com.inq.utils.Util.getConfig("needwaitMessageFirstNoAgentAvailable",com.inq.flash.client.control.messagehandlers.NeedWaitHandler.NEED_WAIT_MESSAGE_DEFAULT);
	this.needwaitMessageFirst = com.inq.utils.Util.getConfig("needwaitMessageFirst",null);
	this.needwaitMessageFirstSoon = com.inq.utils.Util.getConfig("needwaitMessageFirstSoon",null);
	this.needwaitMessageFirstMinutes = com.inq.utils.Util.getConfig("needwaitMessageFirstMinutes",null);
	this.needwaitMessageFirstSeconds = com.inq.utils.Util.getConfig("needwaitMessageFirstSeconds",null);
	this.needwaitMessage = com.inq.utils.Util.getConfig("needwaitMessage",null);
	this.needwaitMessageMinutes = com.inq.utils.Util.getConfig("needwaitMessageMinutes",null);
	this.needwaitMessageSeconds = com.inq.utils.Util.getConfig("needwaitMessageSeconds",null);
	this.needwaitMessageSoon = com.inq.utils.Util.getConfig("needwaitMessageSoon",null);
	this.useMinuteForWaitMessageSoon = com.inq.utils.Util.getConfig("useMinuteForWaitMessageSoon",false);
	this.needwaitSoon = com.inq.utils.Util.getConfig("needwaitSoon",10);
	this.needwaitPeriod = com.inq.utils.Util.getConfig("needwaitPeriod",null);
	this.needWaitSequenceMessages = com.inq.utils.Util.getConfig("needWaitSequenceMessages",null);
	this.processingBehavior = com.inq.utils.Util.getConfig("processingBehavior",com.inq.flash.client.control.messagehandlers.NeedWaitHandler.LEGACY_MESSAGE_PROCESSING);

	this.queueMessagingHandler = new com.inq.flash.client.control.messagehandlers.QueueMessagingHandler(this);

	this.isEnabled = this.queueMessagingHandler.isEnabled
				|| (this.needwaitMessageFirst != null && this.needwaitMessage != null && this.needwaitPeriod != null);
	this.needwaitThreshold = this.needwaitPeriod != null ? this.needwaitPeriod * 10 - 1 : 10;

	this.curCountHit = 0;
	this.curNum = 0;

	/* by default LEGACY_MESSAGE_PROCESSING */
	if (this.processingBehavior == com.inq.flash.client.control.messagehandlers.NeedWaitHandler.SEQUENCE_MESSAGE_PROCESSING
		&& !this.queueMessagingHandler.isEnabled
	) {
		this.isEnabled = true;
		this.initNeedWaitSequenceList(this.needWaitSequenceMessages);
	}

	/* time shift for the first message */
	this.lastProcessedWaitMsg = new Date().getTime();

	haxe.Log.trace("NeedWaitHandler isEnabled = " + Std.string(this.isEnabled),{ fileName : "NeedWaitHandler.hx", lineNumber : 136, className : "com.inq.flash.client.control.messagehandlers.NeedWaitHandler", methodName : "new"});
};
$hxClasses.extend(com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler, com.inq.flash.client.control.messagehandlers.NeedWaitHandler, "com.inq.flash.client.control.messagehandlers.NeedWaitHandler");

/** @private @type {number} */
com.inq.flash.client.control.messagehandlers.NeedWaitHandler.cntMessage = null;
/** @private @type {Array} */
com.inq.flash.client.control.messagehandlers.NeedWaitHandler.needWaitSequenceList = null;

/**
 * incrementCounter - increment the number of queue messages
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function incrementCounter()
 * @public
 * @static
 * @author fpinn@touchcommerce.com
 * @see ChatCommunicationMessageHandler 
 * @return {void}
 */
com.inq.flash.client.control.messagehandlers.NeedWaitHandler.incrementCounter = function() {
	com.inq.flash.client.control.messagehandlers.NeedWaitHandler.cntMessage++;
};


/**
 * initNeedWaitSequenceList
 * message format: "message1 | 5 |10 // message2 |-1 | 40"
 * 
 * *
 * --------------------- *
 *
 * $type TFun([{ name => messages, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * private static function initNeedWaitSequenceList(messages:String)
 * @private
 * @static
 * @param {string}  messages 
 * @return {void}
 */
com.inq.flash.client.control.messagehandlers.NeedWaitHandler.prototype.initNeedWaitSequenceList = function(messages) {
	haxe.Log.trace("start initNeedWaitSequenceList function",{ fileName : "NeedWaitHandler.hx", lineNumber : 369, className : "com.inq.flash.client.control.messagehandlers.NeedWaitHandler", methodName : "initNeedWaitSequenceList"});
	if (!messages) {
		messages = com.inq.flash.client.control.messagehandlers.NeedWaitHandler.NEED_WAIT_SEQUENCE_MESSAGE;
		com.inq.flash.client.control.FlashPeer.logErrorToServer("Skin file " + com.inq.ui.SkinLoader.getSkinURL() + " contains wrong configuration of needWait sequence messages");
	}
	/** @type {Array} */
	var arrayMessages = messages.split("//");
	com.inq.flash.client.control.messagehandlers.NeedWaitHandler.needWaitSequenceList = new Array();
	this.curNum = com.inq.flash.client.control.PersistenceManager.GetValue(QUEUE_MESSAGE_ID, 0);
	var /** @type {number} */ _g = this.curNum;
	while(_g < arrayMessages.length) {
		var /** @type {string} */ message = arrayMessages[_g];
		++_g;
		/*  parts array contains  Actual message, number of hits, time shift */
		/** @type {Array} */
		var parts = message.split("|");
		haxe.Log.trace("Part s of message" + messages,{ fileName : "NeedWaitHandler.hx", lineNumber : 376, className : "com.inq.flash.client.control.messagehandlers.NeedWaitHandler", methodName : "initNeedWaitSequenceList"});

		/** @type {com.inq.flash.client.control.messagehandlers.NeedWaitSequenceMessage} */
		var sequenceMessage = new com.inq.flash.client.control.messagehandlers.NeedWaitSequenceMessage();
		sequenceMessage.setNeedWaitMessage(parts[0]);
		if (_g == arrayMessages.length && Std.parseInt(parts[1]) != -1) {
			//Last element onf Sequence List always should be "-1".
			sequenceMessage.setCountHit(-1);
			var skinURL = com.inq.flash.client.control.FlashPeer.getSkin();
			com.inq.flash.client.control.FlashPeer.logError("Skin file " + skinURL + " contains wrong count hint value, last count hint value should be -1", {message:""});
		} else if (_g == this.curNum + 1) {
			//adjust countHit value for the first message by the qmCnt value from PersistenceManager
			this.curCountHit = com.inq.flash.client.control.PersistenceManager.GetValue(QUEUE_MESSAGE_COUNT,Std.parseInt(parts[1]));
			sequenceMessage.setCountHit(this.curCountHit);
		} else {
			sequenceMessage.setCountHit(Std.parseInt(parts[1]));
		}
		sequenceMessage.setTimeShift(Std.parseFloat(parts[2]));
		com.inq.flash.client.control.messagehandlers.NeedWaitHandler.needWaitSequenceList.push(sequenceMessage);
	}
};


/**
 * sendQueueingMsgString
 *
 * $type TFun([{ name => agentName, t => TInst(String,[]), opt => false },{ name => queueingMsgString, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * private function sendQueueingMsgString(agentName:String,queueingMsgString:String)
 * @private
 * @this com.inq.flash.client.control.messagehandlers.NeedWaitHandler
 * @param {string}  agentName 
 * @param {string}  queueingMsgString
 * @param {string} restoreMode - will be "1" when page with chat is reloaded
 * @return {void}
 */
com.inq.flash.client.control.messagehandlers.NeedWaitHandler.prototype.sendQueueingMsgString = function(agentName, queueingMsgString, restoreMode) {
	queueingMsgString = com.inq.utils.StringUtil.escapeSpecialCharacters(queueingMsgString);
	var messageTimestamp = new Date();
	/** @type {number} */
	var position = com.inq.flash.client.chatskins.SkinControl.AddTranscriptItemToChatWindow(agentName, queueingMsgString, com.inq.flash.client.chatskins.ChatTextArea.AGENT, -1, null, restoreMode, "", messageTimestamp);
	com.inq.flash.client.chatskins.SkinControl.getApplicationController().sendQueueingText(queueingMsgString,position,agentName);
};


/**
 * sequenceMessageProcessing
 * This function implements SEQUENCE_MESSAGE_PROCESSING strategy for display of array messages (RTDEV-11).
 *
 * message format:
 *  "message1 | {countHint} |{timeShift} // message2 | {countHint} | {timeShift} // message3 | {countHint} | {timeShift} // ... // message N | -1 | {timeShift}"
 *  countHint - defines how many times a message will be displayed
 *  timeShift - defines time interval from previous message
 *  if countHint is -1 a message will be displayed infinitely
 *
 * Sample:
 *  needWaitSequenceMessages: "message1 | 1 | 10 // message2 | -1 | 10",
 *  processingBehavior: "SEQUENCE_MESSAGE_PROCESSING"
 *
 * NOTE:
 * It is IMPORTANT that the last message in the sequence have a countHint value "-1".
 * Even if another value is configured the "-1" value used.
 *
 * private function sequenceMessageProcessing(agentName:String)
 * @private
 * @this com.inq.flash.client.control.messagehandlers.NeedWaitHandler
 * @param {string}  agentName - agent's name will be displayed to client
 * @param {string} restoreMode - will be "1" when page with chat is reloaded
 * @return {void}
 */
com.inq.flash.client.control.messagehandlers.NeedWaitHandler.prototype.sequenceMessageProcessing = function(agentName, restoreMode) {
	/** @type {string} */
	var queueingMsgString = com.inq.flash.client.control.messagehandlers.NeedWaitHandler.NEED_WAIT_MESSAGE_DEFAULT;
	/** @type {number} */
	var now = new Date().getTime();
	/** @type {number} */
	var period = (now - this.lastProcessedWaitMsg) / 1000;

	if(period < com.inq.flash.client.control.messagehandlers.NeedWaitHandler.needWaitSequenceList[0].getTimeShift()) {
		haxe.Log.trace("NeedWaitHandler (sequenceMessageProcessing): period is to short " + period,{ fileName : "NeedWaitHandler.hx", lineNumber : 323, className : "com.inq.flash.client.control.messagehandlers.NeedWaitHandler", methodName : "sequenceMessageProcessing"});
	} else {
		haxe.Log.trace("NeedWaitHandler (sequenceMessageProcessing): message period is: " + period + " secs",{ fileName : "NeedWaitHandler.hx", lineNumber : 327, className : "com.inq.flash.client.control.messagehandlers.NeedWaitHandler", methodName : "sequenceMessageProcessing"});
		/*  message will be displayed {countHit} times,
		 *  countHit will be reduced after each show
		 */
		if (com.inq.flash.client.control.messagehandlers.NeedWaitHandler.needWaitSequenceList[0].getCountHit() > 1) {
			com.inq.flash.client.control.messagehandlers.NeedWaitHandler.needWaitSequenceList[0].decrCount();
			queueingMsgString = com.inq.flash.client.control.messagehandlers.NeedWaitHandler.needWaitSequenceList[0].getNeedWaitMessage();
		} else {
			/* countHit is 1, message should be displayed only once
			 * and will be removed from array
			 */
			if (com.inq.flash.client.control.messagehandlers.NeedWaitHandler.needWaitSequenceList[0].getCountHit() == 1) {
				queueingMsgString = com.inq.flash.client.control.messagehandlers.NeedWaitHandler.needWaitSequenceList.shift().getNeedWaitMessage();
				this.curNum++;
			} else {
				/* message will be displayed infinitely */
				if (com.inq.flash.client.control.messagehandlers.NeedWaitHandler.needWaitSequenceList[0].getCountHit() == -1) {
					queueingMsgString = com.inq.flash.client.control.messagehandlers.NeedWaitHandler.needWaitSequenceList[0].getNeedWaitMessage();
				}
			}
		}
		if (com.inq.flash.client.control.messagehandlers.NeedWaitHandler.needWaitSequenceList.length > 0) {
			this.curCountHit = com.inq.flash.client.control.messagehandlers.NeedWaitHandler.needWaitSequenceList[0].getCountHit();
		} else {
			this.curCountHit = 0;
		}
		com.inq.flash.client.control.PersistenceManager.SetValue(QUEUE_MESSAGE_ID, this.curNum);
		com.inq.flash.client.control.PersistenceManager.SetValue(QUEUE_MESSAGE_COUNT, this.curCountHit);

		this.sendQueueingMsgString(agentName, queueingMsgString);
		this.lastProcessedWaitMsg = now;
	}
};


/**
 * legacyMessageProcessing
 * Upon receiving the message:
 * 1) checks if enabled
 * 2) if enabled checks the needwait period and compares it to the internal counter
 * 3) when the internal counter reaches the needwait period,
 * then the needwaitMessage is displayed in the chat text area.
 * Added functionality: http://dev.inq.com/jira/browse/REQ-1938
 * Added an initial message to be output on first instance of need-wait, called needwaitMessageFirst
 * All other subsequent messages will be output as before.
 *
 * $type TFun([{ name => message, t => TInst(com.inq.flash.messagingframework.Message,[]), opt => false },{ name => agentName, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * private function legacyMessageProcessing(message:Message, agentName:String)
 * @private
 * @this com.inq.flash.client.control.messagehandlers.NeedWaitHandler
 * @param {com.inq.flash.messagingframework.Message}  message -  of type Message. 
 * @param {string}  agentName - agent's name will be displayed to client 
 * @return {void}
 */
com.inq.flash.client.control.messagehandlers.NeedWaitHandler.prototype.legacyMessageProcessing = function(message,agentName) {
	/** @type {string} */
	var queueingMsgString;
	if(++com.inq.flash.client.control.messagehandlers.NeedWaitHandler.cntMessage == 0) {
		queueingMsgString = this.substituteWaitTime(message,this.needwaitMessageFirst,this.needwaitMessageFirstSoon,this.needwaitMessageFirstSeconds,this.needwaitMessageFirstMinutes,this.needwaitMessageFirstNoAgentAvailable,this.needwaitMessageFirstDefault);
		queueingMsgString = this.substituteQPFromMessage(queueingMsgString, this.needwaitMessageFirstDefault, message);

		this.sendQueueingMsgString(agentName, queueingMsgString, message.getProperty(com.inq.flash.client.data.MessageFields.KEY_REPLAY));
		
		this.lastProcessedWaitMsg = new Date().getTime();
		return;
	}/*  REQ-1938*//*  REQ-1938*/
	/** @type {number} */
	var now = new Date().getTime();
	/** @type {number} */
	var period = (now - this.lastProcessedWaitMsg) / 1000.0;

	if(period < 3)
		haxe.Log.trace("NeedWaitHandler: period is to short " + period,{ fileName : "NeedWaitHandler.hx", lineNumber : 297, className : "com.inq.flash.client.control.messagehandlers.NeedWaitHandler", methodName : "legacyMessageProcessing"});
	else if(period >= this.needwaitThreshold) {
		haxe.Log.trace("NeedWaitHandler: message period is: " + period + " secs",{ fileName : "NeedWaitHandler.hx", lineNumber : 301, className : "com.inq.flash.client.control.messagehandlers.NeedWaitHandler", methodName : "legacyMessageProcessing"});
		queueingMsgString = this.substituteWaitTime(message,this.needwaitMessage,this.needwaitMessageSoon,this.needwaitMessageSeconds,this.needwaitMessageMinutes,this.needwaitMessageNoAgentAvailable,this.needwaitMessageDefault);
		queueingMsgString = this.substituteQPFromMessage(queueingMsgString, this.needwaitMessageDefault, message);
		
		this.sendQueueingMsgString(agentName, queueingMsgString, message.getProperty(com.inq.flash.client.data.MessageFields.KEY_REPLAY));
		this.lastProcessedWaitMsg = now;
		++com.inq.flash.client.control.messagehandlers.NeedWaitHandler.cntMessage;
	}
};


/**
 * substituteWaitTime - substitute pattern in text with the text specified in a message property
 *
 * $type TFun([{ name => message, t => TInst(com.inq.flash.messagingframework.Message,[]), opt => false },{ name => waitText, t => TInst(String,[]), opt => false },{ name => waitTextSoon, t => TInst(String,[]), opt => false },{ name => waitTextSeconds, t => TInst(String,[]), opt => false },{ name => waitTextMinutes, t => TInst(String,[]), opt => false },{ name => waitTextNoAgentsAvailable, t => TInst(String,[]), opt => false },{ name => waitTextDefault, t => TInst(String,[]), opt => false }],TInst(String,[]))
 * private function substituteWaitTime(message:Message, waitText:String, waitTextSoon:String, waitTextSeconds:String, waitTextMinutes:String, waitTextNoAgentsAvailable:String, waitTextDefault:String):String
 * @private
 * @this com.inq.flash.client.control.messagehandlers.NeedWaitHandler
 * @author fpinn@touchcommerce.com
 * @exampleText "An agent will be with you in <<APPX-WAIT-TIME>> seconds"
 * @exampleText "You are number <<QUEUE-POSITION>> in the queue"
 * @param {com.inq.flash.messagingframework.Message}  message - message from chat-router with the property for replacement 
 * @param {string}  waitText - the base text with text strings to be replaced 
 * @param {string}  waitTextSoon - the base text with text strings to be replaced for things happening soon, seconds less then the threshold (needwaitSoon) 
 * @param {string}  waitTextSeconds - the base text with text strings to be replaced for things happening in second time frame (less than 60 seconds) 
 * @param {string}  waitTextMinutes - the base text with text strings to be replaced for things happening in minute/second time frame  
 * @param {string}  waitTextNoAgentsAvailable - special case when KEY_CHAT_WAIT_EST_ASSIGN_TIME==-1, no agents are available 
 * @param {string}  waitTextDefault 
 * @return {string}
 */
com.inq.flash.client.control.messagehandlers.NeedWaitHandler.prototype.substituteWaitTime = function(message,waitText,waitTextSoon,waitTextSeconds,waitTextMinutes,waitTextNoAgentsAvailable,waitTextDefault) {
	/** @type {string} */
	var queueingMsgString = waitText;
	/** @type {?string} */
	var waitTime = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_CHAT_WAIT_EST_ASSIGN_TIME);
	if(waitTime != null) {
		/** @type {?number} */
		var milliSecondWaitTime = Std.parseInt(waitTime);
		/** @type {number} */
		var secondWaitTime = Math.floor(milliSecondWaitTime / 1000);

		/** @type {number} */
		var minutes = Math.floor(secondWaitTime / 60);
		/** @type {number} */
		var seconds = Math.floor(secondWaitTime % 60);
		/** @type {number} */
		var minutesOnly = Math.round(secondWaitTime / 60);
		/** @type {number} */
		var secondsOnly = Math.floor(secondWaitTime);
		if(minutes > 0 && waitTextMinutes != null) {
			queueingMsgString = this.substituteText(waitTextMinutes,waitTextDefault,com.inq.flash.client.control.messagehandlers.NeedWaitHandler.MINUTE_WAIT_TIME,"" + minutes);
			queueingMsgString = this.substituteText(queueingMsgString,waitTextDefault,com.inq.flash.client.control.messagehandlers.NeedWaitHandler.MINUTES_ONLY_WAIT_TIME,"" + minutesOnly);
			queueingMsgString = this.substituteText(queueingMsgString,waitTextDefault,com.inq.flash.client.control.messagehandlers.NeedWaitHandler.SECOND_WAIT_TIME,"" + seconds);
		} else if(milliSecondWaitTime == -1 && waitTextNoAgentsAvailable != null) {
			queueingMsgString = waitTextNoAgentsAvailable;
		} else if((secondWaitTime < this.needwaitSoon || milliSecondWaitTime == 0) && waitTextSoon != null) {
			/* for special case wait-time == 0, then it will be less than the default needwaitSoon */
			if(this.useMinuteForWaitMessageSoon) {
				queueingMsgString = this.substituteText(waitTextSoon, waitTextDefault, com.inq.flash.client.control.messagehandlers.NeedWaitHandler.MINUTES_ONLY_WAIT_TIME, "" + minutes);
			} else {
				queueingMsgString =
				this.substituteText(waitTextSoon, waitTextDefault, com.inq.flash.client.control.messagehandlers.NeedWaitHandler.SECOND_WAIT_TIME, "" + seconds);
			}
		} else if(waitTextSeconds != null) {
			queueingMsgString = this.substituteText(waitTextSeconds,waitTextDefault,com.inq.flash.client.control.messagehandlers.NeedWaitHandler.SECOND_WAIT_TIME,"" + seconds);
			queueingMsgString = this.substituteText(queueingMsgString,waitTextDefault,com.inq.flash.client.control.messagehandlers.NeedWaitHandler.SECONDS_ONLY_WAIT_TIME,"" + secondsOnly);
		} else {
			queueingMsgString = this.substituteText(waitText,waitTextDefault,com.inq.flash.client.control.messagehandlers.NeedWaitHandler.SECOND_WAIT_TIME,"" + seconds);
			queueingMsgString = this.substituteText(queueingMsgString,waitTextDefault,com.inq.flash.client.control.messagehandlers.NeedWaitHandler.SECONDS_ONLY_WAIT_TIME,"" + secondsOnly);
			queueingMsgString = this.substituteText(queueingMsgString,waitTextDefault,com.inq.flash.client.control.messagehandlers.NeedWaitHandler.MINUTE_WAIT_TIME,"" + minutes);
			queueingMsgString = this.substituteText(queueingMsgString,waitTextDefault,com.inq.flash.client.control.messagehandlers.NeedWaitHandler.MINUTES_ONLY_WAIT_TIME,"" + minutesOnly);
		}
	}
	return queueingMsgString;
};


/**
 * substituteText - substitute pattern in text with the text specified in the substitution.
 *
 * public function substituteText(text:String, defaultText:String, pattern:String, substitute:String):String
 * @public
 * @this com.inq.flash.client.control.messagehandlers.NeedWaitHandler
 * @author fpinn@touchcommerce.com
 * @exampleText "An agent will be with you in <<APPX-WAIT-TIME>> seconds"
 * @exampleText "You are number <<QUEUE-POSITION>> in the queue"
 * @param {string}  text - the text to be searched for the given pattern parameter 
 * @param {string}  defaultText - the text string to be used if parameter is in text but missing in the supplied property of the message 
 * @param {(string|RegExp)}  pattern - the pattern to be matched and substituted
 * @param {string=}  substitute - string for text to be replaced
 * @return {string}
 */
com.inq.flash.client.control.messagehandlers.NeedWaitHandler.prototype.substituteText = function(text,defaultText,pattern,substitute) {
	if (substitute == null) {
		/* If substitution text is missing, then substitute the text with the default text */
		return defaultText;
	} else {
		/* The substitution text is available, so let's use it */
		return text.replace(pattern, substitute);
	}
};


/**
 * substituteTextFromMessage - substitute pattern in text with the text specified in a message property
 *
 * $type TFun([{ name => text, t => TInst(String,[]), opt => false },{ name => defaultText, t => TInst(String,[]), opt => false },{ name => pattern, t => TInst(String,[]), opt => false },{ name => message, t => TInst(com.inq.flash.messagingframework.Message,[]), opt => false },{ name => property, t => TInst(String,[]), opt => false }],TInst(String,[]))
 * private function substituteTextFromMessage(text:String, defaultText:String, pattern:String, message:Message, property:String):String
 * @private
 * @this com.inq.flash.client.control.messagehandlers.NeedWaitHandler
 * @author fpinn@touchcommerce.com
 * @exampleText "An agent will be with you in <<APPX-WAIT-TIME>> seconds"
 * @exampleText "You are number <<QUEUE-POSITION>> in the queue"
 * @param {string}  text - the text to be searched for the given pattern parameter
 * @param {string}  defaultText - the text string to be used if parameter is in text but missing in the supplied property of the message
 * @param {string}  pattern - the pattern to be matched and substituted
 * @param {com.inq.flash.messagingframework.Message}  message - message from chat-router with the property for replacement
 * @param {string}  property - name of the property containing the substitution text
 * @return {string}
 */
com.inq.flash.client.control.messagehandlers.NeedWaitHandler.prototype.substituteTextFromMessage = function(text,defaultText,pattern,message,property) {
	/** @type {string} */
	var substitute = message.getProperty(property);/* Get the substiution text from message */
	return this.substituteText(text,defaultText,pattern,substitute);
};

/**
 * substituteQPFromMessage - substitute QUEUE_POSITION in text
 * with the text specified in a message property KEY_CHAT_WAIT_POS
 * @example "You are number <<QUEUE-POSITION>> in the queue"
 * // "You are number 3 in the queue"
 *
 * @public
 * @this com.inq.flash.client.control.messagehandlers.NeedWaitHandler
 *
 * @param {string} text - the text to be searched for the given pattern parameter
 * @param {string} defaultText - the text string to be used if parameter is in text but missing in the supplied property of the message
 * @param {com.inq.flash.messagingframework.Message} message - message from Chat Router with the property for replacement
 * @return {string}
 */
com.inq.flash.client.control.messagehandlers.NeedWaitHandler.prototype.substituteQPFromMessage = function(text, defaultText, message) {
	return this.substituteText(text, defaultText,
		com.inq.flash.client.control.messagehandlers.NeedWaitHandler.QUEUE_POSITION,
		message.getProperty(com.inq.flash.client.data.MessageFields.KEY_CHAT_WAIT_POS));
};

/**
 * substituteQP - substitute QUEUE_POSITION in text
 * with the text specified in a position parameter.
 *
 * @param {string} text - the text to be searched for the given pattern parameter
 * @param {string} defaultText - the text string to be used if parameter is in text but missing in the supplied property of the message
 * @param {string} position - value for the replacement
 */
com.inq.flash.client.control.messagehandlers.NeedWaitHandler.prototype.substituteQP = function(text, defaultText, position) {
    return this.substituteText(text, defaultText,
        com.inq.flash.client.control.messagehandlers.NeedWaitHandler.QUEUE_POSITION,
        position);
    };

/**
 * processMessage handler for NeedWaitHander
 * Accepts the message from the server and handles any actions involved.
 *
 * override public function processMessage(message:Message):Void
 * @override
 * @public
 * @this com.inq.flash.client.control.messagehandlers.NeedWaitHandler
 * @param {com.inq.flash.messagingframework.Message}  message 
 * @return {void}
 */
com.inq.flash.client.control.messagehandlers.NeedWaitHandler.prototype.processMessage = function(message) {
	haxe.Log.trace("Processing message behavior: " + this.processingBehavior,{ fileName : "NeedWaitHandler.hx", lineNumber : 146, className : "com.inq.flash.client.control.messagehandlers.NeedWaitHandler", methodName : "processMessage"});

	if (message.data["isWaitMsgFirst"] == "true") {
		com.inq.flash.client.control.messagehandlers.NeedWaitHandler.cntMessage = -1;
	}

	var params = {
		queuePos: message.getProperty(com.inq.flash.client.data.MessageFields.KEY_CHAT_WAIT_POS),
		queueTime: message.getProperty(com.inq.flash.client.data.MessageFields.KEY_CHAT_WAIT_EST_ASSIGN_TIME)
	};
	com.inq.flash.client.chatskins.SkinControl.sendEventToAllAutomatons("onChatInQueue", params);

	if(!this.isEnabled) return;

	com.inq.flash.client.chatskins.SkinControl.getApplicationController().setFlagChatInQueue(true);

	/** @type {string} */
	var agentName = com.inq.flash.client.control.FlashVars.getFlashVars().agentName;
    if (com.inq.utils.Util.isDefaultAgentAlias()) {
        agentName = com.inq.utils.Util.getConfig("defaultAgentAlias", "&nbsp;");
    }

	if (this.queueMessagingHandler.isEnabled) {
        this.queueMessagingHandler.msgProcessing(message, agentName);
	} else {
		//otherwise show messages of previous version (chat skin configuration)
		if (this.processingBehavior == com.inq.flash.client.control.messagehandlers.NeedWaitHandler.LEGACY_MESSAGE_PROCESSING) {
			this.legacyMessageProcessing(message, agentName);
		} else if (this.processingBehavior == com.inq.flash.client.control.messagehandlers.NeedWaitHandler.SEQUENCE_MESSAGE_PROCESSING) {
			this.sequenceMessageProcessing(agentName, message.getProperty(com.inq.flash.client.data.MessageFields.KEY_REPLAY));
		}
	}
};

com.inq.flash.client.control.messagehandlers.NeedWaitHandler.prototype.clearQueueMessageTimer = function() {
	this.queueMessagingHandler.clearPendingTimer();
};

/** @private @type {string} */
com.inq.flash.client.control.messagehandlers.NeedWaitHandler.prototype.processingBehavior = null;
/** @private @type {string} */
com.inq.flash.client.control.messagehandlers.NeedWaitHandler.prototype.needWaitSequenceMessages = null;
/** @private @type {boolean} */
com.inq.flash.client.control.messagehandlers.NeedWaitHandler.prototype.isEnabled = null;
/** @private @type {number} */
com.inq.flash.client.control.messagehandlers.NeedWaitHandler.prototype.needwaitThreshold = null;
/** @private @type {null} */
com.inq.flash.client.control.messagehandlers.NeedWaitHandler.prototype.needwaitPeriod = null;
/** @private @type {number} */
com.inq.flash.client.control.messagehandlers.NeedWaitHandler.prototype.needwaitSoon = null;
/** @private @type {string} */
com.inq.flash.client.control.messagehandlers.NeedWaitHandler.prototype.needwaitMessageMinutes = null;
/** @private @type {string} */
com.inq.flash.client.control.messagehandlers.NeedWaitHandler.prototype.needwaitMessageSeconds = null;
/** @private @type {string} */
com.inq.flash.client.control.messagehandlers.NeedWaitHandler.prototype.needwaitMessageSoon = null;
/** @private @type {boolean} */
com.inq.flash.client.control.messagehandlers.NeedWaitHandler.prototype.useMinuteForWaitMessageSoon = false;
/** @private @type {string} */
com.inq.flash.client.control.messagehandlers.NeedWaitHandler.prototype.needwaitMessage = null;
/** @private @type {string} */
com.inq.flash.client.control.messagehandlers.NeedWaitHandler.prototype.needwaitMessageFirstMinutes = null;
/** @private @type {string} */
com.inq.flash.client.control.messagehandlers.NeedWaitHandler.prototype.needwaitMessageFirstSeconds = null;
/** @private @type {string} */
com.inq.flash.client.control.messagehandlers.NeedWaitHandler.prototype.needwaitMessageFirstSoon = null;
/** @private @type {string} */
com.inq.flash.client.control.messagehandlers.NeedWaitHandler.prototype.needwaitMessageFirst = null;
/** @private @type {string} */
com.inq.flash.client.control.messagehandlers.NeedWaitHandler.prototype.needwaitMessageNoAgentAvailable = null;
/** @private @type {string} */
com.inq.flash.client.control.messagehandlers.NeedWaitHandler.prototype.needwaitMessageFirstNoAgentAvailable = null;
/** @private @type {string} */
com.inq.flash.client.control.messagehandlers.NeedWaitHandler.prototype.needwaitMessageDefault = null;
/** @private @type {string} */
com.inq.flash.client.control.messagehandlers.NeedWaitHandler.prototype.needwaitMessageFirstDefault = null;
/** @private @type {number} */
com.inq.flash.client.control.messagehandlers.NeedWaitHandler.prototype.lastProcessedWaitMsg = null;
/** @type {com.inq.flash.client.control.messagehandlers.NeedWaitHandler} */
com.inq.flash.client.control.messagehandlers.NeedWaitHandler.prototype.__class__ = com.inq.flash.client.control.messagehandlers.NeedWaitHandler;
/** @private @type {string} */
com.inq.flash.client.control.messagehandlers.NeedWaitHandler.NEED_WAIT_MESSAGE_FIRST_DEFAULT = "Sorry for the delay, please wait";

/** @private @type {string} */
com.inq.flash.client.control.messagehandlers.NeedWaitHandler.NEED_WAIT_MESSAGE_DEFAULT = "Still busy, please wait";

/** @private @type {string} */
com.inq.flash.client.control.messagehandlers.NeedWaitHandler.APPX_WAIT_TIME = "<<APPX-WAIT-TIME>>";

/** @private @type {string} */
com.inq.flash.client.control.messagehandlers.NeedWaitHandler.MINUTE_WAIT_TIME = "<<MINUTE-WAIT-TIME>>";

/** @private @type {string} */
com.inq.flash.client.control.messagehandlers.NeedWaitHandler.MINUTES_ONLY_WAIT_TIME = "<<MINUTES-ONLY-WAIT-TIME>>";

/** @private @type {string} */
com.inq.flash.client.control.messagehandlers.NeedWaitHandler.SECOND_WAIT_TIME = "<<SECOND-WAIT-TIME>>";

/** @private @type {string} */
com.inq.flash.client.control.messagehandlers.NeedWaitHandler.SECONDS_ONLY_WAIT_TIME = "<<SECONDS-ONLY-WAIT-TIME>>";

/** @private @type {string} */
com.inq.flash.client.control.messagehandlers.NeedWaitHandler.QUEUE_POSITION = "<<QUEUE-POSITION>>";

/** @private @type {string} */
com.inq.flash.client.control.messagehandlers.NeedWaitHandler.NEED_WAIT_SEQUENCE_MESSAGE = com.inq.flash.client.control.messagehandlers.NeedWaitHandler.NEED_WAIT_MESSAGE_FIRST_DEFAULT + "|1|30" +
	"//" + com.inq.flash.client.control.messagehandlers.NeedWaitHandler.NEED_WAIT_MESSAGE_DEFAULT + "|-1|60";

/** @private @type {string} */
com.inq.flash.client.control.messagehandlers.NeedWaitHandler.LEGACY_MESSAGE_PROCESSING = "LEGACY_MESSAGE_PROCESSING";

/** @private @type {string} */
com.inq.flash.client.control.messagehandlers.NeedWaitHandler.SEQUENCE_MESSAGE_PROCESSING = "SEQUENCE_MESSAGE_PROCESSING";

